import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export default function MinimizeIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.33333H1.13333C2.25344 4.33333 2.81349 4.33333 3.24131 4.11535C3.61764 3.9236 3.9236 3.61764 4.11535 3.24131C4.33333 2.81349 4.33333 2.25344 4.33333 1.13333V1M1 9.66667H1.13333C2.25344 9.66667 2.81349 9.66667 3.24131 9.88465C3.61764 10.0764 3.9236 10.3824 4.11535 10.7587C4.33333 11.1865 4.33333 11.7466 4.33333 12.8667V13M9.66667 1V1.13333C9.66667 2.25344 9.66667 2.81349 9.88465 3.24131C10.0764 3.61764 10.3824 3.9236 10.7587 4.11535C11.1865 4.33333 11.7466 4.33333 12.8667 4.33333H13M9.66667 13V12.8667C9.66667 11.7466 9.66667 11.1865 9.88465 10.7587C10.0764 10.3824 10.3824 10.0764 10.7587 9.88465C11.1865 9.66667 11.7466 9.66667 12.8667 9.66667H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
